import React from 'react';
import SwipeableViews from 'react-swipeable-views';
import { Paper } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Pagination as MuiPagination, PaginationItem as MuiPaginationItem } from '@material-ui/lab';

const useStyles = makeStyles({
  paginationContainer: {
    backgroundColor: '#ffffff',
    display: 'grid',
    gridTemplateRows: '1fr 2.5rem',
    gridGap: '0.5rem',
    minHeight: '55vh',
    maxHeight: 'calc(100vh - 80px)',
  },
  navigationContainer: {
    backgroundColor: '#e3e3e3',
  }
});

const StyledSwipeableViews = withStyles(theme => ({
  root: {
    height: '100%',
  },
}))(SwipeableViews);

const SlideContainer = withStyles(theme => ({
  root: {
    height: '100%',
    overflow: 'hidden',
    borderRadius: "25px 25px 0 0",
  }
}))(Paper);

const StyledPagination = withStyles({
  root: {
    backgroundColor: '#e3e3e3',
    display: 'flex',
  },
  ul: {
    flexGrow: 1,
    justifyContent: 'center',
  },
})(MuiPagination);

const PaginationItem = withStyles({
  root: {
    color: '#606060',
    fontSize: '12px',
  }
})(MuiPaginationItem);

interface PageData<Page> {
  data: Page;
  index?: number;
}

interface PaginationProps<Page> {
  pages: Page[];
  currentPage: number;
  setCurrentPage: (page: number) => void;
  renderItem: ({ data, index }: PageData<Page>) => JSX.Element;
  getKey?: ({ data, index }: PageData<Page>) => string | number;
}

const Pagination = <Page extends { id?: string | number }>({
  currentPage,
  getKey = ({data, index}) => data?.id ?? index!,
  pages,
  renderItem,
  setCurrentPage,
}: PaginationProps<Page>) => {
  const classes = useStyles();
  return (
    <div className={classes.paginationContainer}>
      <StyledSwipeableViews
        enableMouseEvents
        index={currentPage}
        onChangeIndex={setCurrentPage}
        containerStyle={{
          height: '100%'
        }}
      >
        {pages.map((data, index) => (
          <SlideContainer
            key={getKey({data, index})}
            elevation={0}
          >
            {renderItem({data, index})}
          </SlideContainer>
        ))}
      </StyledSwipeableViews>
      <StyledPagination
        count={pages.length}
        onChange={(event: React.ChangeEvent<unknown>, pageIndex: number) => setCurrentPage(pageIndex - 1)} // pages are 1-indexed via paginator
        page={currentPage + 1}
        renderItem={(item) => <PaginationItem {...item} />}
      />
    </div>
  );
};

export default Pagination;
